import { render, staticRenderFns } from "./RowBlockRefundFundsCanceledContractDgo.vue?vue&type=template&id=5d3dff34&"
import script from "./RowBlockRefundFundsCanceledContractDgo.vue?vue&type=script&lang=js&"
export * from "./RowBlockRefundFundsCanceledContractDgo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports